
import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { PermissionService } from 'app/core/auth/permission.service';

@Component({
    selector: 'vg-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './sidebar.component.html'
})
export class VgSidebarComponent implements OnInit {
    @Input() collapsed: boolean = false;
    userName: string = 'User';
    userRole: string = '';

    // Role flags
    isAdmin: boolean = false;
    isManager: boolean = false;
    isKasir: boolean = false;
    isLoket: boolean = false;

    // Combined access flags for template
    canManage: boolean = false;     // Admin + Manager
    canKasir: boolean = false;      // Admin + kasirvoucher
    canAllocate: boolean = false;   // Admin + Manager + Loket
    canLogView: boolean = false;    // Admin + Manager + Loket + Kasir

    constructor(
        private _authService: AuthService,
        private _permissionService: PermissionService
    ) {}

    ngOnInit(): void {
        const user = this._authService.getCurrentUser();
        if (user) {
            this.userName = user.name || user.username || 'User';

            // Check roles
            this.isAdmin = this._permissionService.hasRole('ADMIN');
            this.isManager = this._permissionService.hasRole('Managerial');
            this.isKasir = this._permissionService.hasRole('KasirVoucher');
            this.isLoket = this._permissionService.hasRole('Loket');

            // Combined access: Admin can access everything
            this.canManage = this.isAdmin || this.isManager;
            this.canKasir = this.isAdmin || this.isKasir;
            this.canAllocate = this.isAdmin || this.isManager || this.isLoket;
            this.canLogView = this.isAdmin || this.isManager || this.isLoket ||  this.isKasir;

            // Display role label
            if (this.isAdmin) {
                this.userRole = 'Admin';
            } else if (this.isManager) {
                this.userRole = 'Managerial';
            } else if (this.isLoket) {
                this.userRole = 'Loket';
            } else if (this.isKasir) {
                this.userRole = 'Kasir Voucher';
            } else if (user.roles && user.roles.length > 0) {
                this.userRole = user.roles[0];
            } else {
                this.userRole = 'User';
            }
        }
    }
}

